import { JetView } from 'webix-jet';
import { devConfig, profile } from 'config/config';

/**
 * FilterView class extends JetView to create a filter interface.
 */
export default class FilterView extends JetView {
    /**
     * Configures the UI components of the FilterView.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const screen = this.app.config.size; // Current screen size

        // Filter section configuration
        const filter = {
            margin: 15,
            rows: [
                {
                    margin: 15,
                    css: 'on-row',
                    cols: [
                        {
                            view: 'richselect', // Dropdown for selecting Partner
                            name: 'Partner',
                            label: _('Partner'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            options: profile.Partners, // Options from profile
                        },
                        {
                            view: 'richselect', // Dropdown for selecting activation status
                            name: 'IsActivate',
                            label: "<span class='icon-state'></span>" + _('Estado'),
                            labelPosition: 'top',
                            placeholder: _('Click para seleccionar '),
                            value: '',
                            options: [
                                { id: '', value: _('Todos') }, // All option
                                { id: 'A', value: _('Activo') }, // Active option
                                { id: 'I', value: _('Inactivo') }, // Inactive option
                            ],
                        },
                        { id: 'grav', gravity: 2 }, // Gravity for layout
                    ],
                },
            ],
        };

        // Button section configuration
        const buttons = {
            id: 'b2',
            rows: [
                {
                    margin: 10,
                    responsive: 'b2',
                    cols: [
                        { id: 'grav2', gravity: 1 }, // Gravity for layout
                        {
                            view: 'button', // Clear button
                            value: _('Limpiar'),
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                this.getRoot().clear(); // Clears the filter inputs
                            },
                        },
                        {
                            view: 'button', // Consult button
                            value: _('Consultar'),
                            hotkey: 'enter', // Hotkey for the button
                            type: 'form',
                            width: screen == 'small' ? 0 : 100,
                            minWidth: 200,
                            click: () => {
                                const filterdata = this.getRoot().getValues(); // Get filter values
                                this.app.callEvent('partnersList:filter', [
                                    filterdata, // Trigger filter event with data
                                ]);
                                $$('b5').collapse(); // Collapse the accordion
                            },
                        },
                    ],
                },
            ],
        };

        // Upper section configuration
        const upper_section = {
            id: 'a1',
            css: 'father-container',
            height: screen == 'small' ? 140 : 0, // Conditional height based on screen size
            rows: [
                {
                    responsive: 'a1',
                    margin: 10,
                    cols: [filter], // Include filter in the upper section
                },
            ],
        };

        // Accordion section configuration
        const accordion_section2 = {
            type: 'wide',
            rows: [
                {
                    multi: true,
                    view: 'accordion', // Accordion for filters
                    css: 'betShop',
                    collapsed: false,
                    type: 'clean',
                    rows: [
                        {
                            header: _('Filtros'), // Header for the accordion
                            id: 'b5',
                            body: {
                                padding: 10,
                                rows: [upper_section, buttons], // Include upper section and buttons
                            },
                        },
                    ],
                },
            ],
        };

        // Return the main configuration for the form
        return {
            view: 'form',
            type: 'clean',
            rows: [accordion_section2], // Include accordion section in the form
            rules: {
                fname: webix.rules.isNotEmpty, // Validation rule for non-empty fields
            },
        };
    }

    /**
     * Initializes the view and sets up responsive behavior.
     * @param {Object} grid - The grid component to initialize.
     */
    init(grid) {
        webix.ready(function () {
            if (screen.width < 500) {
                // Check screen width for responsive design
                $$('grav').hide(); // Hide element if screen is small
                $$('grav2').hide(); // Hide another element if screen is small
            }
        });
    }
}

// FILE DOCUMENTED
